import React, { Component } from 'react'
import { rollupTimeEntriesByUser } from '../../common/pages/dashboard'
import { withinSpanChecker } from '../../util/date_utils'
import * as timeUtils from '../../util/time_utils'
import TimeEntryList from './time_entry_list'
import Avatar from '../avatar'
import { getDisplayName } from '../../util/name_utils'
import { calcContainerHeight } from '../../util/scroll_display_utils'

class TimeEntryListByUser extends Component {
    constructor(props) {
        super(props)

        this.state = {
            areNoEntries: true,
        }

        this.ref = null

        this.setRef = el => {
            this.ref = el
        }
    }

    componentDidMount() {
        this.setState({scrollWindowHeight: calcContainerHeight(this.ref)})
        window.addEventListener('resize', this.resizeScrollContainer)
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.trialEnd != this.props.trialEnd) {
            this.setState({scrollWindowHeight: calcContainerHeight(this.ref)})
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeScrollContainer)
    }

    resizeScrollContainer = () => {
        this.setState({scrollWindowHeight: calcContainerHeight(this.ref)})
    }

    setAreNoEntries = (bool) => {
        this.setState({userIdCount: bool})
    }

    getSpanEntries = (timeEntriesArray, range) => {
        const { start, end } = range
        const isWithinRange = withinSpanChecker(start, end)
        return timeEntriesArray.filter(tr => isWithinRange(tr.startAt))
    }

    renderUserBlock = (userId, timeEntries, rollups, index) => {
        const { selectedTeamMembership, tags, teams, isCollapsed, increment,
            createTimeEntry, updateTimeEntry, editTimeEntry, trialEnd, showByUser,
        } = this.props

        if (!selectedTeamMembership || !selectedTeamMembership.items) {
            return undefined
        }

        const selectedTeamMember = selectedTeamMembership.items[userId]

        if (!selectedTeamMember) {
            return undefined
        }

        const { fullName: name, primaryEmail } = selectedTeamMember
        if (!primaryEmail) {
            return undefined
        }

        const total = rollups.reduce((acc, r) => acc + r.total, 0)
        const totalHrs = timeUtils.msToHrsRounded(total)

        return (
            <div className="time-entry-list-by-user" key={userId + index}>
                <div className="user-title-row">
                    <Avatar emailAddress={primaryEmail} name={name} />
                    <h3>{getDisplayName(name, primaryEmail)}</h3>
                    <span className="total">{totalHrs}</span>
                </div>

                <TimeEntryList
                    timeEntries={timeEntries}
                    timeEntryRollups={rollups}
                    tags={tags}
                    increment={increment}
                    createTimeEntry={createTimeEntry}
                    updateTimeEntry={updateTimeEntry}
                    teams={teams}
                    editTimeEntry={editTimeEntry}
                    isCollapsed={isCollapsed}
                    trialEnd={trialEnd}
                    showByUser={showByUser}
                />
            </div>
        )
    }

    renderNoEntries() {
        return (
            <div className="time-entry-rollup-empty" ref={this.setRef}>
                <div className="no-entry-title">No entries for this date range</div>
                <div className="break-line"></div>
                <span className="no-entry-subtitle">Select a different range or create a new entry</span>
            </div>
        )
    }

    render() {
        const { timeEntriesArray, runningEntries, viewport } = this.props
        const { scrollWindowHeight } = this.state
        const { range: { increment, start, end }, collapse } = viewport
        const spanEntries = this.getSpanEntries(timeEntriesArray, viewport.range)
        const interval = collapse ? increment : 'Day'

        const timeEntriesByUser = rollupTimeEntriesByUser(spanEntries, interval, { start, end }, runningEntries, collapse)
        const userIds = Object.keys(timeEntriesByUser)

        if (userIds.length < 1) {
            return this.renderNoEntries()
        }

        return (
            <div className="time-entry-list-by-user-container scroll-window" style={{height: scrollWindowHeight}} ref={this.setRef}>
                {userIds.map((userId, index) =>
                    this.renderUserBlock(
                        userId,
                        timeEntriesByUser[userId].timeEntries,
                        timeEntriesByUser[userId].rollups,
                        index,
                    )
                )}
            </div>
        )
    }
}

export default TimeEntryListByUser


// WEBPACK FOOTER //
// ./src/components/layout/time_entry_list_by_user.jsx